// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2fW98","label":"CategoryService_label__1gYud","location":"CategoryService_location__3d6TG"};